module.exports = __webpack_public_path__ + "static/sky_bg-632fc5b3ded88fe6431f1817af22b774.svg";